import Alpine from 'alpinejs';

Alpine.data("swymWishlistButton", (productId, variantId, productUrl) => ({
    productId: productId,
    variantId: variantId,
    productUrl: productUrl,
    wishlists: [],
    get isInWishlist() {
        return this.wishlists.some(list =>
            Array.isArray(list.listcontents) &&
            list.listcontents.some(item => item.epi === this.variantId)
        );
    },
    init(){
        this.waitForSwymApi().then(() => {
            this.$dispatch(new CustomEvent('swym-wishlist:ready'));

            this.reload().then((lists) => {
                if (! lists || lists.length === 0) {
                    console.warn("No wishlists found for the user.");

                    window.SwymCallbacks.push((swat) => {
                        swat.createList(
                            {
                                lname: "My Wishlist",
                            },
                            (newList) => {
                                console.log("Wishlist created:", newList);
                                this.wishlists = [newList];
                            }
                        );
                    });
                }else {   
                    this.wishlists = lists;
                }
            }).catch((error) => {
                console.error(`Error loading wishlist: ${error}`);
            });
        }).catch((error) => {
            console.error(`Wishlist failed to load: ${error}`);
        });
    },
    get isReady() {
        return this.wishlists.length > 0;
    },
    reload() {
        return new Promise((resolve, reject) => {
            window.SwymCallbacks.push((swat) => {
                swat.fetchLists({
                    callbackFn: (lists) => {
                        resolve(lists);
                    },
                    errorFn: (error) => {
                        reject(error);
                    }
                });
            });
        });
    },
    toggle() {
        new Promise((resolve, reject) => {
            window.SwymCallbacks.push((swat) => {
                let listId = this.wishlists.length > 0 ? this.wishlists[0].lid : null;

                if (! listId) {
                    reject("No wishlist found to add/remove item.");
                    return;
                }

                let product = {
                    epi: this.variantId,
                    empi: this.productId,
                    du: this.productUrl,
                };

                if (this.isInWishlist) {
                    swat.deleteFromList(listId, product, () => {
                        this.$dispatch(
                            'swym-wishlist:item-removed', 
                            { 
                                variantId: product.epi,
                                productId: product.empi
                            }
                        );

                        resolve(`Product ${product.epi} removed from wishlist`);
                    });
                } else {
                    swat.addToList(listId, product, () => {
                        this.$dispatch(
                            'swym-wishlist:item-added', 
                            { 
                                variantId: product.epi,
                                productId: product.empi
                            } 
                        );

                        resolve(`Product ${product.epi} added to wishlist`);
                    });
                }
            });
        }).then(() => {
            this.reload().then((lists) => {
                this.wishlists = lists;
            }).catch((error) => {
                console.error(`Error reloading wishlist: ${error}`);
            });

        }).catch((error) => {
            console.error(`Error toggling wishlist status: ${error}`);
        });
    },
    waitForSwymApi() {
        return new Promise((resolve, reject) => {
            let maxTries = 20;
            let interval = setInterval(() => {
                if (window._swat !== undefined) {
                    clearInterval(interval);
                    resolve();
                }

                maxTries--;

                if (maxTries <= 0) {
                    clearInterval(interval);
                    reject("Wishlist API failed to load");
                }
            }, 1000);
        });
    }
}))